const hideBodyScroll = function(){
    $('body').addClass('hideScroll');
}

const showBodyScroll = function(){
    $('body').removeClass('hideScroll');
}

export {hideBodyScroll, showBodyScroll}